import { Injectable } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { StorageService } from './storage.service';

interface GalleryHierarchyItem {
  galleryId: string;
  childrenIds: string[];
  childrenPaths: string[];
}

@Injectable({
  providedIn: 'root',
})
export class ViewGalleryHierarchyService {
  hierarchies: GalleryHierarchyItem[] = [];

  constructor(private storage: StorageService) {
    this.hierarchies = this.storage.get('view-gallery-hierarchy') || [];
  }

  add(gallery: GalleryDto, childrenIds: string[] = [], childrenPaths: string[]) {
    const value = this.getParent(gallery.id);
    if (value) {
      childrenIds.forEach(id => {
        if (!value.childrenIds.includes(id)) value.childrenIds.push(id);
      });
      childrenPaths.forEach(path => {
        if (!value.childrenPaths.includes(path)) value.childrenPaths.push(path);
      });
    } else {
      this.hierarchies.push({ galleryId: gallery.id, childrenIds, childrenPaths });
    }
    this.storage.set('view-gallery-hierarchy', this.hierarchies);
  }

  getParent(childGalleryIdOrPath: string) {
    return this.hierarchies.find(
      h => h.childrenIds.includes(childGalleryIdOrPath) || h.childrenPaths.includes(childGalleryIdOrPath)
    );
  }
}
